import React, { useContext, useEffect, useState } from "react";
import { addUser } from "../actions/userRegister";
import { useNavigate } from "react-router-dom";
import { AlertContext } from "../context/MainContext";

import { PatternFormat } from "react-number-format";

const Register = () => {
  // Basic Registration
  const [email_address, setEmail_Address] = useState(null);
  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const [legal_first_name, setLegal_First_Name] = useState(null);
  const [legal_last_name, setLegal_Last_Name] = useState(null);
  const [profession, setProfession] = useState("");
  const [phoneNumber, setPhone_Number] = useState(null);
  const [companyName, setCompanyName] = useState(null);
  const [position, setPosition] = useState(null);
  const [brokerageName, setBrokerageName] = useState(null);
  const [brokerageNumber, setBrokerageNumber] = useState(null);
  const [brokerName, setBrokerName] = useState(null);
  const [brokerNumber, setBrokerNumber] = useState(null);
  const [brokeragePhone, setBrokeragePhone] = useState(null);
  const [brokerageEmail, setBrokerageEmail] = useState(null);

  // NEW: Realtor sub-type flags
  const [isRealtor, setIsRealtor] = useState(null);
  const [isBroker, setIsBroker] = useState(null);

  // NEW: Builder Sales Agent fields
  const [builderNumber, setBuilderNumber] = useState(null);
  const [builderEmail, setBuilderEmail] = useState(null);
  const [builderSupervisorName, setBuilderSupervisorName] = useState(null);
  const [builderSupervisorEmail, setBuilderSupervisorEmail] = useState(null);

  // NEW: Title Company Closer fields
  const [titleCompanyName, setTitleCompanyName] = useState(null);
  const [titleCompanyAddress, setTitleCompanyAddress] = useState(null);
  const [titleCompanyPhone, setTitleCompanyPhone] = useState(null);
  const [titleCompanySupervisorName, setTitleCompanySupervisorName] =
    useState(null);
  const [titleCompanySupervisorEmail, setTitleCompanySupervisorEmail] =
    useState(null);

  // NEW: Lender fields
  const [companyLicenseNumber, setCompanyLicenseNumber] = useState(null);
  const [supervisorName, setSupervisorName] = useState(null);
  const [supervisorLicenseNumber, setSupervisorLicenseNumber] = useState(null);
  const [branchAddress, setBranchAddress] = useState(null);
  const [branchPhone, setBranchPhone] = useState(null);

  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);
  const [registered, setRegistered] = useState(false);
  const [waitingMessage, setWaitingMessage] = useState(null);
  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({});
  const [missingModal, setMissingModal] = useState({ show: false, fields: [] });

  // Advanced registration to validate their position
  const [professionId, setProfessionId] = useState(null);
  const { alert, setAlert } = useContext(AlertContext);
  const nav = useNavigate();

  // Update alert when waiting message changes (for cold start feedback)
  useEffect(() => {
    if (waitingMessage) {
      setAlert([
        "Please Wait",
        `${waitingMessage}\n\nDo not close this window or navigate away.`,
        "waiting",
      ]);
    }
  }, [waitingMessage, setAlert]);

  const fieldLabels = {
    profession: "Profession",
    username: "Username",
    email_address: "Email Address",
    password: "Password",
    legal_first_name: "Legal First Name",
    legal_last_name: "Legal Last Name",
    phoneNumber: "Phone Number",
    professionId: "License Id #",
    position: "Position",
    companyName: "Company Name",
    brokerageName: "Brokerage",
    brokerageNumber: "Brokerage License #",
    brokerName: "Broker Name",
    brokerNumber: "Broker License #",
    brokeragePhone: "Brokerage Telephone #",
    brokerageEmail: "Brokerage E-Mail",
    isRealtor: "Are you a Realtor (NAR Member)?",
    isBroker: "Are you a Broker?",
    builderNumber: "Builder Number",
    builderEmail: "Builder Email",
    builderSupervisorName: "Builder Supervisor Name",
    builderSupervisorEmail: "Builder Supervisor Email",
    titleCompanyName: "Title Company Name",
    titleCompanyAddress: "Title Company Address",
    titleCompanyPhone: "Title Company Phone",
    titleCompanySupervisorName: "Title Company Supervisor",
    titleCompanySupervisorEmail: "Title Company Supervisor Email",
    companyLicenseNumber: "Company License Number",
    supervisorName: "Loan Supervisor Name",
    supervisorLicenseNumber: "Supervisor License Number",
    branchAddress: "Branch Address",
    branchPhone: "Branch Phone Number",
  };

  const getRequiredFields = (prof) => {
    const required = [
      "profession",
      "email_address",
      "password",
      "legal_first_name",
      "legal_last_name",
    ];

    if (prof === "Consumer") {
      required.push("username", "phoneNumber");
    }

    if (prof === "Realtor") {
      required.push("isRealtor", "professionId", "phoneNumber");
      // If is_realtor=true AND is_broker=true, add broker fields
      if (isRealtor === true && isBroker === true) {
        required.push(
          "brokerageName",
          "brokerageNumber",
          "brokerName",
          "brokerNumber",
          "brokeragePhone",
          "brokerageEmail",
        );
      }
    }

    if (prof === "Builder") {
      required.push("builderNumber", "builderEmail");
    }

    if (prof === "Title Company") {
      required.push(
        "titleCompanyName",
        "titleCompanyAddress",
        "titleCompanyPhone",
        "phoneNumber",
      );
    }

    if (prof === "Lender") {
      required.push(
        "professionId",
        "companyLicenseNumber",
        "supervisorName",
        "supervisorLicenseNumber",
        "branchAddress",
        "branchPhone",
        "phoneNumber",
      );
    }

    // Keep backward compatibility with existing Advertiser and Broker options
    if (prof === "Advertiser") {
      required.push("professionId");
    }

    if (prof === "Broker") {
      required.push(
        "professionId",
        "brokerageName",
        "brokerageNumber",
        "brokerName",
        "brokerNumber",
        "brokeragePhone",
        "brokerageEmail",
        "phoneNumber",
      );
    }

    return required;
  };

  const getValueByKey = (key) => {
    const map = {
      profession,
      username,
      email_address,
      password,
      legal_first_name,
      legal_last_name,
      phoneNumber,
      professionId,
      position,
      companyName,
      brokerageName,
      brokerageNumber,
      brokerName,
      brokerNumber,
      brokeragePhone,
      brokerageEmail,
      isRealtor,
      isBroker,
      builderNumber,
      builderEmail,
      builderSupervisorName,
      builderSupervisorEmail,
      titleCompanyName,
      titleCompanyAddress,
      titleCompanyPhone,
      titleCompanySupervisorName,
      titleCompanySupervisorEmail,
      companyLicenseNumber,
      supervisorName,
      supervisorLicenseNumber,
      branchAddress,
      branchPhone,
    };
    return map[key];
  };

  const validateField = (key) => {
    const required = getRequiredFields(profession);
    if (required.includes(key) && !getValueByKey(key)) {
      return "This field is required";
    }
    return "";
  };

  const handleBlur = (key) => {
    setTouched((prev) => ({ ...prev, [key]: true }));
    const message = validateField(key);
    setErrors((prev) => ({ ...prev, [key]: message }));
  };

  const handleChange = (key, setter) => (e) => {
    const value = e.target.value;
    setter(value);
    if (touched[key]) {
      const message = validateField(key);
      setErrors((prev) => ({ ...prev, [key]: message }));
    }
  };
  useEffect(() => {
    if (err) {
      setAlert(["Registration Failed", err, "failed"]);
    }
  }, [err, setAlert]);
  const handleSubmit = () => {
    const required = getRequiredFields(profession);
    const missing = required.filter((key) => !getValueByKey(key));

    if (missing.length > 0) {
      const newErrors = { ...errors };
      missing.forEach((key) => {
        newErrors[key] = "This field is required";
      });
      setErrors(newErrors);
      const touchedUpdate = { ...touched };
      missing.forEach((key) => {
        touchedUpdate[key] = true;
      });
      setTouched(touchedUpdate);
      setMissingModal({
        show: true,
        fields: missing.map((m) => fieldLabels[m] || m),
      });
      setErr("Please complete the required fields below.");
      return;
    }

    setErr(null);
    setLoading(true);
    setAlert([
      "Submitting your account",
      "We are sending your registration for approval. This may take a moment.",
      "waiting",
    ]);

    addUser(
      username,
      email_address,
      password,
      legal_first_name,
      legal_last_name,
      profession,
      phoneNumber,
      professionId,
      companyName,
      position,
      brokerageName,
      brokerageNumber,
      brokerName,
      brokerNumber,
      brokeragePhone,
      brokerageEmail,
      // NEW PARAMETERS:
      isRealtor,
      isBroker,
      builderNumber,
      builderEmail,
      builderSupervisorName,
      builderSupervisorEmail,
      titleCompanyName,
      titleCompanyAddress,
      titleCompanyPhone,
      titleCompanySupervisorName,
      titleCompanySupervisorEmail,
      companyLicenseNumber,
      supervisorName,
      supervisorLicenseNumber,
      branchAddress,
      branchPhone,
      { setLoading, setErr, setRegistered, setWaitingMessage },
      500,
    );
  };
  useEffect(() => {
    if (registered) {
      setAlert([
        "Registration submitted",
        "Your account is pending review. You will get an email once it is approved or denied.",
        "confirm",
      ]);
      nav("/");
    }
  }, [registered]);

  return (
    <div className="min-h-screen flex items-center justify-center py-16 px-4">
      <div className="w-full max-w-2xl bg-white shadow-2xl rounded-2xl overflow-hidden border border-slate-200">
        {/* Header Section */}
        <div className="bg-gradient-to-br from-blue-700 via-blue-600 to-blue-500 text-white p-8 text-center">
          <h1 className="text-4xl font-bold mb-2">Create Your Account</h1>
        </div>

        {/* Form Section */}
        <div className="p-8">
          {err && (
            <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-red-600 text-sm font-medium">{err}</p>
            </div>
          )}

          <div className="space-y-6">
            {/* Profession Field */}
            <div className="flex flex-col gap-2">
              <label className="text-sm font-medium text-slate-700 flex items-center gap-1">
                Profession <span className="text-red-600">*</span>
              </label>
              <p className="text-xs text-slate-500 -mt-1">
                This site promotes those in the real estate industry
              </p>
              <select
                className={`bg-slate-100 px-4 py-3 rounded-lg border ${
                  errors.profession
                    ? "border-red-500"
                    : "border-slate-200 focus:border-blue-500"
                } focus:outline-none`}
                value={profession}
                onChange={(e) => {
                  setProfession(e.target.value);
                  if (touched.profession) {
                    const message = validateField("profession");
                    setErrors((prev) => ({ ...prev, profession: message }));
                  }
                }}
                onBlur={() => handleBlur("profession")}
              >
                <option value="">Select your profession...</option>
                <option>Consumer</option>
                <option>Realtor</option>
                <option>Lender</option>
                <option>Broker</option>
                <option>Builder</option>
                <option>Advertiser</option>
                <option>Title Company</option>
              </select>
              {errors.profession && (
                <span className="text-sm text-red-600">
                  {errors.profession}
                </span>
              )}
            </div>

            {/* Consumer Username */}
            {profession === "Consumer" && (
              <>
                <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg">
                  <p className="text-xs text-blue-700">
                    Note: Your legal name will not be publicly displayed
                  </p>
                </div>
                <div className="flex flex-col gap-2">
                  <label className="text-sm font-medium text-slate-700 flex items-center gap-1">
                    Username <span className="text-red-600">*</span>
                  </label>
                  <input
                    className={`bg-slate-100 px-4 py-3 rounded-lg border ${
                      errors.username
                        ? "border-red-500"
                        : "border-slate-200 focus:border-blue-500"
                    } focus:outline-none`}
                    onChange={handleChange("username", setUsername)}
                    onBlur={() => handleBlur("username")}
                    placeholder="Choose a username"
                  />
                  {errors.username && (
                    <span className="text-sm text-red-600">
                      {errors.username}
                    </span>
                  )}
                </div>
              </>
            )}

            {/* License ID for certain professions (hidden for Broker since included below) */}
            {profession !== "" &&
              profession !== "Consumer" &&
              profession !== "Title Company" &&
              profession !== "Builder" &&
              profession !== "Broker" && (
                <div className="flex flex-col gap-2">
                  <label className="text-sm font-medium text-slate-700 flex items-center gap-1">
                    License ID # <span className="text-red-600">*</span>
                  </label>
                  <input
                    className={`bg-slate-100 px-4 py-3 rounded-lg border ${
                      errors.professionId
                        ? "border-red-500"
                        : "border-slate-200 focus:border-blue-500"
                    } focus:outline-none`}
                    onChange={handleChange("professionId", setProfessionId)}
                    onBlur={() => handleBlur("professionId")}
                    placeholder="Enter your license number"
                  />
                  {errors.professionId && (
                    <span className="text-sm text-red-600">
                      {errors.professionId}
                    </span>
                  )}
                </div>
              )}

            {/* Position and Company for Title Company/Builder */}
            {(profession === "Title Company" || profession === "Builder") && (
              <>
                <div className="flex flex-col gap-2">
                  <label className="text-sm font-medium text-slate-700 flex items-center gap-1">
                    Position <span className="text-red-600">*</span>
                  </label>
                  <input
                    className={`bg-slate-100 px-4 py-3 rounded-lg border ${
                      errors.position
                        ? "border-red-500"
                        : "border-slate-200 focus:border-blue-500"
                    } focus:outline-none`}
                    onChange={handleChange("position", setPosition)}
                    onBlur={() => handleBlur("position")}
                    placeholder="Your position/title"
                  />
                  {errors.position && (
                    <span className="text-sm text-red-600">
                      {errors.position}
                    </span>
                  )}
                </div>
                {profession === "Title Company" && (
                  <div className="flex flex-col gap-2">
                    <label className="text-sm font-medium text-slate-700 flex items-center gap-1">
                      Title Company Name <span className="text-red-600">*</span>
                    </label>
                    <input
                      className={`bg-slate-100 px-4 py-3 rounded-lg border ${
                        errors.companyName
                          ? "border-red-500"
                          : "border-slate-200 focus:border-blue-500"
                      } focus:outline-none`}
                      onChange={handleChange("companyName", setCompanyName)}
                      onBlur={() => handleBlur("companyName")}
                      placeholder="Company name"
                    />
                    {errors.companyName && (
                      <span className="text-sm text-red-600">
                        {errors.companyName}
                      </span>
                    )}
                  </div>
                )}
              </>
            )}

            {/* Email Address */}
            <div className="flex flex-col gap-2">
              <label className="text-sm font-medium text-slate-700 flex items-center gap-1">
                Email Address <span className="text-red-600">*</span>
              </label>
              <input
                className={`bg-slate-100 px-4 py-3 rounded-lg border ${
                  errors.email_address
                    ? "border-red-500"
                    : "border-slate-200 focus:border-blue-500"
                } focus:outline-none`}
                type="email"
                onChange={handleChange("email_address", setEmail_Address)}
                onBlur={() => handleBlur("email_address")}
                placeholder="you@example.com"
              />
              {errors.email_address && (
                <span className="text-sm text-red-600">
                  {errors.email_address}
                </span>
              )}
            </div>

            {/* Password */}
            <div className="flex flex-col gap-2">
              <label className="text-sm font-medium text-slate-700 flex items-center gap-1">
                Password <span className="text-red-600">*</span>
              </label>
              <input
                className={`bg-slate-100 px-4 py-3 rounded-lg border ${
                  errors.password
                    ? "border-red-500"
                    : "border-slate-200 focus:border-blue-500"
                } focus:outline-none`}
                type="password"
                onChange={handleChange("password", setPassword)}
                onBlur={() => handleBlur("password")}
                placeholder="Create a password"
              />
              {errors.password && (
                <span className="text-sm text-red-600">{errors.password}</span>
              )}
            </div>

            {/* Name Fields */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="flex flex-col gap-2">
                <label className="text-sm font-medium text-slate-700 flex items-center gap-1">
                  Legal First Name <span className="text-red-600">*</span>
                </label>
                <input
                  className={`bg-slate-100 px-4 py-3 rounded-lg border ${
                    errors.legal_first_name
                      ? "border-red-500"
                      : "border-slate-200 focus:border-blue-500"
                  } focus:outline-none`}
                  onChange={handleChange(
                    "legal_first_name",
                    setLegal_First_Name,
                  )}
                  onBlur={() => handleBlur("legal_first_name")}
                  placeholder="First name"
                />
                {errors.legal_first_name && (
                  <span className="text-sm text-red-600">
                    {errors.legal_first_name}
                  </span>
                )}
              </div>
              <div className="flex flex-col gap-2">
                <label className="text-sm font-medium text-slate-700 flex items-center gap-1">
                  Legal Last Name <span className="text-red-600">*</span>
                </label>
                <input
                  className={`bg-slate-100 px-4 py-3 rounded-lg border ${
                    errors.legal_last_name
                      ? "border-red-500"
                      : "border-slate-200 focus:border-blue-500"
                  } focus:outline-none`}
                  onChange={handleChange("legal_last_name", setLegal_Last_Name)}
                  onBlur={() => handleBlur("legal_last_name")}
                  placeholder="Last name"
                />
                {errors.legal_last_name && (
                  <span className="text-sm text-red-600">
                    {errors.legal_last_name}
                  </span>
                )}
              </div>
            </div>

            {/* Phone Number */}
            {profession !== "Builder" && (
              <div className="flex flex-col gap-2">
                <label className="text-sm font-medium text-slate-700 flex items-center gap-1">
                  Phone Number <span className="text-red-600">*</span>
                </label>
                <PatternFormat
                  className={`bg-slate-100 px-4 py-3 rounded-lg border ${
                    errors.phoneNumber
                      ? "border-red-500"
                      : "border-slate-200 focus:border-blue-500"
                  } focus:outline-none`}
                  format="+1 (###) ### ####"
                  onChange={(e) => {
                    setPhone_Number(e.target.value);
                    if (touched.phoneNumber) {
                      const message = validateField("phoneNumber");
                      setErrors((prev) => ({ ...prev, phoneNumber: message }));
                    }
                  }}
                  onBlur={() => handleBlur("phoneNumber")}
                  allowEmptyFormatting
                  mask="_"
                  placeholder="+1 (___) ___ ____"
                />
                {errors.phoneNumber && (
                  <span className="text-sm text-red-600">
                    {errors.phoneNumber}
                  </span>
                )}
              </div>
            )}

            {/* Info Notice */}
            <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg">
              <p className="text-xs text-blue-700">
                You'll be able to edit and add more information from your
                control panel after registration
              </p>
              <p className="text-xs text-blue-700 mt-2">
                Important: Your legal first and last name — and any brokerage or
                licensing fields you provide — cannot be changed later except by
                an administrator. Please enter them carefully.
              </p>
            </div>

            {/* Broker-specific fields (show when profession === 'Broker') - moved earlier and grouped */}
            {profession === "Broker" && (
              <div className="p-4 rounded-lg border border-slate-200 bg-slate-50 space-y-4">
                <h3 className="text-sm font-semibold text-slate-700">
                  Brokerage Information
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="flex flex-col">
                    <label className="text-sm">Brokerage</label>
                    <input
                      className={`bg-white px-4 py-3 rounded-lg border ${
                        errors.brokerageName
                          ? "border-red-500"
                          : "border-slate-200"
                      }`}
                      onChange={handleChange("brokerageName", setBrokerageName)}
                      onBlur={() => handleBlur("brokerageName")}
                      placeholder="Brokerage name"
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="text-sm">Brokerage License #</label>
                    <input
                      className={`bg-white px-4 py-3 rounded-lg border ${
                        errors.brokerageNumber
                          ? "border-red-500"
                          : "border-slate-200"
                      }`}
                      onChange={handleChange(
                        "brokerageNumber",
                        setBrokerageNumber,
                      )}
                      onBlur={() => handleBlur("brokerageNumber")}
                      placeholder="Brokerage license #"
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="text-sm">Broker Name</label>
                    <input
                      className={`bg-white px-4 py-3 rounded-lg border ${
                        errors.brokerName
                          ? "border-red-500"
                          : "border-slate-200"
                      }`}
                      onChange={handleChange("brokerName", setBrokerName)}
                      onBlur={() => handleBlur("brokerName")}
                      placeholder="Broker full name"
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="text-sm">Broker License #</label>
                    <input
                      className={`bg-white px-4 py-3 rounded-lg border ${
                        errors.brokerNumber
                          ? "border-red-500"
                          : "border-slate-200"
                      }`}
                      onChange={handleChange("brokerNumber", setBrokerNumber)}
                      onBlur={() => handleBlur("brokerNumber")}
                      placeholder="Broker license #"
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="text-sm">Brokerage Telephone #</label>
                    <input
                      className={`bg-white px-4 py-3 rounded-lg border ${
                        errors.brokeragePhone
                          ? "border-red-500"
                          : "border-slate-200"
                      }`}
                      onChange={handleChange(
                        "brokeragePhone",
                        setBrokeragePhone,
                      )}
                      onBlur={() => handleBlur("brokeragePhone")}
                      placeholder="Brokerage telephone"
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="text-sm">Brokerage E-Mail</label>
                    <input
                      className={`bg-white px-4 py-3 rounded-lg border ${
                        errors.brokerageEmail
                          ? "border-red-500"
                          : "border-slate-200"
                      }`}
                      onChange={handleChange(
                        "brokerageEmail",
                        setBrokerageEmail,
                      )}
                      onBlur={() => handleBlur("brokerageEmail")}
                      placeholder="Brokerage email"
                      type="email"
                    />
                  </div>
                </div>
              </div>
            )}

            {/* NEW: Realtor sub-type questions */}
            {profession === "Realtor" && (
              <>
                <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg">
                  <p className="text-xs text-blue-700">
                    Select your professional designation to verify your
                    credentials
                  </p>
                </div>

                {/* Are you a Realtor (NAR member)? */}
                <div className="flex flex-col gap-2">
                  <label className="text-sm font-medium text-slate-700 flex items-center gap-1">
                    Are you a member of the National Association of Realtors
                    (NAR)? <span className="text-red-600">*</span>
                  </label>
                  <div className="flex gap-4">
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="isRealtor"
                        checked={isRealtor === true}
                        onChange={() => {
                          setIsRealtor(true);
                          setIsBroker(null);
                          if (touched.isRealtor) {
                            const message = validateField("isRealtor");
                            setErrors((prev) => ({
                              ...prev,
                              isRealtor: message,
                            }));
                          }
                        }}
                        onBlur={() => handleBlur("isRealtor")}
                      />
                      Yes, I am a Realtor (NAR member)
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="isRealtor"
                        checked={isRealtor === false}
                        onChange={() => {
                          setIsRealtor(false);
                          setIsBroker(null);
                          if (touched.isRealtor) {
                            const message = validateField("isRealtor");
                            setErrors((prev) => ({
                              ...prev,
                              isRealtor: message,
                            }));
                          }
                        }}
                        onBlur={() => handleBlur("isRealtor")}
                      />
                      No, I am a Sales Agent (not NAR member)
                    </label>
                  </div>
                  {errors.isRealtor && (
                    <span className="text-sm text-red-600">
                      {errors.isRealtor}
                    </span>
                  )}
                </div>

                {/* Are you a Broker? - only show if Realtor */}
                {isRealtor === true && (
                  <div className="flex flex-col gap-2">
                    <label className="text-sm font-medium text-slate-700 flex items-center gap-1">
                      Are you a Broker? <span className="text-red-600">*</span>
                    </label>
                    <div className="flex gap-4">
                      <label className="flex items-center gap-2 cursor-pointer">
                        <input
                          type="radio"
                          name="isBroker"
                          checked={isBroker === true}
                          onChange={() => {
                            setIsBroker(true);
                            if (touched.isBroker) {
                              const message = validateField("isBroker");
                              setErrors((prev) => ({
                                ...prev,
                                isBroker: message,
                              }));
                            }
                          }}
                          onBlur={() => handleBlur("isBroker")}
                        />
                        Yes, I run/manage a brokerage
                      </label>
                      <label className="flex items-center gap-2 cursor-pointer">
                        <input
                          type="radio"
                          name="isBroker"
                          checked={isBroker === false}
                          onChange={() => {
                            setIsBroker(false);
                            if (touched.isBroker) {
                              const message = validateField("isBroker");
                              setErrors((prev) => ({
                                ...prev,
                                isBroker: message,
                              }));
                            }
                          }}
                          onBlur={() => handleBlur("isBroker")}
                        />
                        No, I am an individual agent
                      </label>
                    </div>
                    {errors.isBroker && (
                      <span className="text-sm text-red-600">
                        {errors.isBroker}
                      </span>
                    )}
                  </div>
                )}

                {/* Show broker fields only if isBroker === true */}
                {isBroker === true && (
                  <div className="p-4 rounded-lg border border-slate-200 bg-slate-50 space-y-4">
                    <h3 className="text-sm font-semibold text-slate-700">
                      Brokerage Information
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="flex flex-col">
                        <label className="text-sm font-medium text-slate-700">
                          Brokerage <span className="text-red-600">*</span>
                        </label>
                        <input
                          className={`bg-white px-4 py-3 rounded-lg border ${
                            errors.brokerageName
                              ? "border-red-500"
                              : "border-slate-200"
                          }`}
                          onChange={handleChange(
                            "brokerageName",
                            setBrokerageName,
                          )}
                          onBlur={() => handleBlur("brokerageName")}
                          placeholder="Brokerage name"
                        />
                      </div>
                      <div className="flex flex-col">
                        <label className="text-sm font-medium text-slate-700">
                          Brokerage License #{" "}
                          <span className="text-red-600">*</span>
                        </label>
                        <input
                          className={`bg-white px-4 py-3 rounded-lg border ${
                            errors.brokerageNumber
                              ? "border-red-500"
                              : "border-slate-200"
                          }`}
                          onChange={handleChange(
                            "brokerageNumber",
                            setBrokerageNumber,
                          )}
                          onBlur={() => handleBlur("brokerageNumber")}
                          placeholder="Brokerage license #"
                        />
                      </div>
                      <div className="flex flex-col">
                        <label className="text-sm font-medium text-slate-700">
                          Broker Name <span className="text-red-600">*</span>
                        </label>
                        <input
                          className={`bg-white px-4 py-3 rounded-lg border ${
                            errors.brokerName
                              ? "border-red-500"
                              : "border-slate-200"
                          }`}
                          onChange={handleChange("brokerName", setBrokerName)}
                          onBlur={() => handleBlur("brokerName")}
                          placeholder="Broker full name"
                        />
                      </div>
                      <div className="flex flex-col">
                        <label className="text-sm font-medium text-slate-700">
                          Broker License #{" "}
                          <span className="text-red-600">*</span>
                        </label>
                        <input
                          className={`bg-white px-4 py-3 rounded-lg border ${
                            errors.brokerNumber
                              ? "border-red-500"
                              : "border-slate-200"
                          }`}
                          onChange={handleChange(
                            "brokerNumber",
                            setBrokerNumber,
                          )}
                          onBlur={() => handleBlur("brokerNumber")}
                          placeholder="Broker license #"
                        />
                      </div>
                      <div className="flex flex-col">
                        <label className="text-sm font-medium text-slate-700">
                          Brokerage Telephone #{" "}
                          <span className="text-red-600">*</span>
                        </label>
                        <input
                          className={`bg-white px-4 py-3 rounded-lg border ${
                            errors.brokeragePhone
                              ? "border-red-500"
                              : "border-slate-200"
                          }`}
                          onChange={handleChange(
                            "brokeragePhone",
                            setBrokeragePhone,
                          )}
                          onBlur={() => handleBlur("brokeragePhone")}
                          placeholder="Brokerage telephone"
                        />
                      </div>
                      <div className="flex flex-col">
                        <label className="text-sm font-medium text-slate-700">
                          Brokerage E-Mail{" "}
                          <span className="text-red-600">*</span>
                        </label>
                        <input
                          className={`bg-white px-4 py-3 rounded-lg border ${
                            errors.brokerageEmail
                              ? "border-red-500"
                              : "border-slate-200"
                          }`}
                          onChange={handleChange(
                            "brokerageEmail",
                            setBrokerageEmail,
                          )}
                          onBlur={() => handleBlur("brokerageEmail")}
                          placeholder="Brokerage email"
                          type="email"
                        />
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}

            {/* NEW: Builder Sales Agent fields */}
            {profession === "Builder" && (
              <div className="space-y-4 p-4 rounded-lg border border-slate-200 bg-slate-50">
                <h3 className="text-sm font-semibold text-slate-700">
                  Builder Information
                </h3>

                <div className="flex flex-col gap-2">
                  <label className="text-sm font-medium text-slate-700">
                    Builder Company Name <span className="text-red-600">*</span>
                  </label>
                  <input
                    className={`bg-white px-4 py-3 rounded-lg border ${
                      errors.companyName ? "border-red-500" : "border-slate-200"
                    }`}
                    value={companyName || ""}
                    onChange={handleChange("companyName", setCompanyName)}
                    onBlur={() => handleBlur("companyName")}
                    placeholder="e.g., Bob's Builder Homes"
                  />
                  {errors.companyName && (
                    <span className="text-sm text-red-600">
                      {errors.companyName}
                    </span>
                  )}
                </div>

                <div className="flex flex-col gap-2">
                  <label className="text-sm font-medium text-slate-700">
                    Builder Number <span className="text-red-600">*</span>
                  </label>
                  <input
                    className={`bg-white px-4 py-3 rounded-lg border ${
                      errors.builderNumber
                        ? "border-red-500"
                        : "border-slate-200"
                    }`}
                    value={builderNumber || ""}
                    onChange={handleChange("builderNumber", setBuilderNumber)}
                    onBlur={() => handleBlur("builderNumber")}
                    placeholder="Builder reference number"
                  />
                  {errors.builderNumber && (
                    <span className="text-sm text-red-600">
                      {errors.builderNumber}
                    </span>
                  )}
                </div>

                <div className="flex flex-col gap-2">
                  <label className="text-sm font-medium text-slate-700">
                    Builder Email <span className="text-red-600">*</span>
                  </label>
                  <input
                    className={`bg-white px-4 py-3 rounded-lg border ${
                      errors.builderEmail
                        ? "border-red-500"
                        : "border-slate-200"
                    }`}
                    type="email"
                    value={builderEmail || ""}
                    onChange={handleChange("builderEmail", setBuilderEmail)}
                    onBlur={() => handleBlur("builderEmail")}
                    placeholder="company@builder.com"
                  />
                  {errors.builderEmail && (
                    <span className="text-sm text-red-600">
                      {errors.builderEmail}
                    </span>
                  )}
                </div>

                <div className="flex flex-col gap-2">
                  <label className="text-sm font-medium text-slate-700">
                    Supervisor Name (Optional)
                  </label>
                  <input
                    className="bg-white px-4 py-3 rounded-lg border border-slate-200"
                    value={builderSupervisorName || ""}
                    onChange={handleChange(
                      "builderSupervisorName",
                      setBuilderSupervisorName,
                    )}
                    placeholder="Supervisor's name if applicable"
                  />
                </div>

                <div className="flex flex-col gap-2">
                  <label className="text-sm font-medium text-slate-700">
                    Supervisor Email (Optional)
                  </label>
                  <input
                    className="bg-white px-4 py-3 rounded-lg border border-slate-200"
                    type="email"
                    value={builderSupervisorEmail || ""}
                    onChange={handleChange(
                      "builderSupervisorEmail",
                      setBuilderSupervisorEmail,
                    )}
                    placeholder="supervisor@builder.com"
                  />
                </div>
              </div>
            )}

            {/* NEW: Title Company Closer fields */}
            {profession === "Title Company" && (
              <div className="space-y-4 p-4 rounded-lg border border-slate-200 bg-slate-50">
                <h3 className="text-sm font-semibold text-slate-700">
                  Title Company Information
                </h3>

                <div className="flex flex-col gap-2">
                  <label className="text-sm font-medium text-slate-700">
                    Title Company Name <span className="text-red-600">*</span>
                  </label>
                  <input
                    className={`bg-white px-4 py-3 rounded-lg border ${
                      errors.titleCompanyName
                        ? "border-red-500"
                        : "border-slate-200"
                    }`}
                    value={titleCompanyName || ""}
                    onChange={handleChange(
                      "titleCompanyName",
                      setTitleCompanyName,
                    )}
                    onBlur={() => handleBlur("titleCompanyName")}
                    placeholder="Title Company Name"
                  />
                  {errors.titleCompanyName && (
                    <span className="text-sm text-red-600">
                      {errors.titleCompanyName}
                    </span>
                  )}
                </div>

                <div className="flex flex-col gap-2">
                  <label className="text-sm font-medium text-slate-700">
                    Title Company Address{" "}
                    <span className="text-red-600">*</span>
                  </label>
                  <input
                    className={`bg-white px-4 py-3 rounded-lg border ${
                      errors.titleCompanyAddress
                        ? "border-red-500"
                        : "border-slate-200"
                    }`}
                    value={titleCompanyAddress || ""}
                    onChange={handleChange(
                      "titleCompanyAddress",
                      setTitleCompanyAddress,
                    )}
                    onBlur={() => handleBlur("titleCompanyAddress")}
                    placeholder="123 Main Street, City, TX 12345"
                  />
                  {errors.titleCompanyAddress && (
                    <span className="text-sm text-red-600">
                      {errors.titleCompanyAddress}
                    </span>
                  )}
                </div>

                <div className="flex flex-col gap-2">
                  <label className="text-sm font-medium text-slate-700">
                    Title Company Phone <span className="text-red-600">*</span>
                  </label>
                  <input
                    className={`bg-white px-4 py-3 rounded-lg border ${
                      errors.titleCompanyPhone
                        ? "border-red-500"
                        : "border-slate-200"
                    }`}
                    value={titleCompanyPhone || ""}
                    onChange={handleChange(
                      "titleCompanyPhone",
                      setTitleCompanyPhone,
                    )}
                    onBlur={() => handleBlur("titleCompanyPhone")}
                    placeholder="(555) 123-4567"
                  />
                  {errors.titleCompanyPhone && (
                    <span className="text-sm text-red-600">
                      {errors.titleCompanyPhone}
                    </span>
                  )}
                </div>

                <div className="flex flex-col gap-2">
                  <label className="text-sm font-medium text-slate-700">
                    Supervisor Name (Optional)
                  </label>
                  <input
                    className="bg-white px-4 py-3 rounded-lg border border-slate-200"
                    value={titleCompanySupervisorName || ""}
                    onChange={handleChange(
                      "titleCompanySupervisorName",
                      setTitleCompanySupervisorName,
                    )}
                    placeholder="Supervisor's name if applicable"
                  />
                </div>

                <div className="flex flex-col gap-2">
                  <label className="text-sm font-medium text-slate-700">
                    Supervisor Email (Optional)
                  </label>
                  <input
                    className="bg-white px-4 py-3 rounded-lg border border-slate-200"
                    type="email"
                    value={titleCompanySupervisorEmail || ""}
                    onChange={handleChange(
                      "titleCompanySupervisorEmail",
                      setTitleCompanySupervisorEmail,
                    )}
                    placeholder="supervisor@titleco.com"
                  />
                </div>
              </div>
            )}

            {/* NEW: Lender fields */}
            {profession === "Lender" && (
              <div className="space-y-4 p-4 rounded-lg border border-slate-200 bg-slate-50">
                <h3 className="text-sm font-semibold text-slate-700">
                  Lender Information
                </h3>

                <div className="flex flex-col gap-2">
                  <label className="text-sm font-medium text-slate-700">
                    Loan Officer License #{" "}
                    <span className="text-red-600">*</span>
                  </label>
                  <input
                    className={`bg-white px-4 py-3 rounded-lg border ${
                      errors.professionId
                        ? "border-red-500"
                        : "border-slate-200"
                    }`}
                    value={professionId || ""}
                    onChange={handleChange("professionId", setProfessionId)}
                    onBlur={() => handleBlur("professionId")}
                    placeholder="Your Texas loan officer license"
                  />
                  {errors.professionId && (
                    <span className="text-sm text-red-600">
                      {errors.professionId}
                    </span>
                  )}
                </div>

                <div className="flex flex-col gap-2">
                  <label className="text-sm font-medium text-slate-700">
                    Lending Company Name <span className="text-red-600">*</span>
                  </label>
                  <input
                    className={`bg-white px-4 py-3 rounded-lg border ${
                      errors.companyName ? "border-red-500" : "border-slate-200"
                    }`}
                    value={companyName || ""}
                    onChange={handleChange("companyName", setCompanyName)}
                    onBlur={() => handleBlur("companyName")}
                    placeholder="e.g., Texas Home Loans Inc."
                  />
                  {errors.companyName && (
                    <span className="text-sm text-red-600">
                      {errors.companyName}
                    </span>
                  )}
                </div>

                <div className="flex flex-col gap-2">
                  <label className="text-sm font-medium text-slate-700">
                    Company License # <span className="text-red-600">*</span>
                  </label>
                  <input
                    className={`bg-white px-4 py-3 rounded-lg border ${
                      errors.companyLicenseNumber
                        ? "border-red-500"
                        : "border-slate-200"
                    }`}
                    value={companyLicenseNumber || ""}
                    onChange={handleChange(
                      "companyLicenseNumber",
                      setCompanyLicenseNumber,
                    )}
                    onBlur={() => handleBlur("companyLicenseNumber")}
                    placeholder="Company license number"
                  />
                  {errors.companyLicenseNumber && (
                    <span className="text-sm text-red-600">
                      {errors.companyLicenseNumber}
                    </span>
                  )}
                </div>

                <div className="flex flex-col gap-2">
                  <label className="text-sm font-medium text-slate-700">
                    Supervisor Name <span className="text-red-600">*</span>
                  </label>
                  <input
                    className={`bg-white px-4 py-3 rounded-lg border ${
                      errors.supervisorName
                        ? "border-red-500"
                        : "border-slate-200"
                    }`}
                    value={supervisorName || ""}
                    onChange={handleChange("supervisorName", setSupervisorName)}
                    onBlur={() => handleBlur("supervisorName")}
                    placeholder="Your supervisor's name"
                  />
                  {errors.supervisorName && (
                    <span className="text-sm text-red-600">
                      {errors.supervisorName}
                    </span>
                  )}
                </div>

                <div className="flex flex-col gap-2">
                  <label className="text-sm font-medium text-slate-700">
                    Supervisor License # <span className="text-red-600">*</span>
                  </label>
                  <input
                    className={`bg-white px-4 py-3 rounded-lg border ${
                      errors.supervisorLicenseNumber
                        ? "border-red-500"
                        : "border-slate-200"
                    }`}
                    value={supervisorLicenseNumber || ""}
                    onChange={handleChange(
                      "supervisorLicenseNumber",
                      setSupervisorLicenseNumber,
                    )}
                    onBlur={() => handleBlur("supervisorLicenseNumber")}
                    placeholder="Supervisor's license number"
                  />
                  {errors.supervisorLicenseNumber && (
                    <span className="text-sm text-red-600">
                      {errors.supervisorLicenseNumber}
                    </span>
                  )}
                </div>

                <div className="flex flex-col gap-2">
                  <label className="text-sm font-medium text-slate-700">
                    Branch Address <span className="text-red-600">*</span>
                  </label>
                  <input
                    className={`bg-white px-4 py-3 rounded-lg border ${
                      errors.branchAddress
                        ? "border-red-500"
                        : "border-slate-200"
                    }`}
                    value={branchAddress || ""}
                    onChange={handleChange("branchAddress", setBranchAddress)}
                    onBlur={() => handleBlur("branchAddress")}
                    placeholder="123 Main St, City, TX 12345"
                  />
                  {errors.branchAddress && (
                    <span className="text-sm text-red-600">
                      {errors.branchAddress}
                    </span>
                  )}
                </div>

                <div className="flex flex-col gap-2">
                  <label className="text-sm font-medium text-slate-700">
                    Branch Phone <span className="text-red-600">*</span>
                  </label>
                  <input
                    className={`bg-white px-4 py-3 rounded-lg border ${
                      errors.branchPhone ? "border-red-500" : "border-slate-200"
                    }`}
                    value={branchPhone || ""}
                    onChange={handleChange("branchPhone", setBranchPhone)}
                    onBlur={() => handleBlur("branchPhone")}
                    placeholder="(555) 123-4567"
                  />
                  {errors.branchPhone && (
                    <span className="text-sm text-red-600">
                      {errors.branchPhone}
                    </span>
                  )}
                </div>
              </div>
            )}

            {/* Register Button */}
            <button
              onClick={() => handleSubmit()}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-lg shadow-lg shadow-blue-200 transition-all"
            >
              Create Account
            </button>

            {/* Terms */}
            <p className="text-xs text-center text-slate-500">
              By registering you agree to the site's terms and conditions, and
              agree to post only factual information
            </p>
          </div>
        </div>

        {/* Missing Fields Modal */}
        {missingModal.show && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4">
              <h3 className="text-xl font-semibold text-slate-900 mb-2">
                Missing Required Fields
              </h3>
              <p className="text-slate-600 mb-4">
                Please complete the following fields before submitting:
              </p>
              <ul className="list-disc list-inside text-slate-700 mb-6 space-y-1">
                {missingModal.fields.map((f) => (
                  <li key={f}>{f}</li>
                ))}
              </ul>
              <button
                className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all"
                onClick={() => setMissingModal({ show: false, fields: [] })}
              >
                Got it
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Register;
